import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

function toNumber(value) {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isNaN(n) ? null : n;
}

function fkValue(field) {
  if (field === null || field === undefined) return "";
  if (typeof field === "object") return field.id ?? "";
  return field;
}

export default function ForeignKeySelect({ value, options, onChange, getLabel, emptyLabel }) {
  const labelOf = getLabel || ((o) => o.name || `#${o.id}`);
  return (
    <Input
      type="select"
      bsSize="sm"
      className="custom-select"
      value={fkValue(value)}
      onChange={(e) => onChange(e.target.value === "" ? null : toNumber(e.target.value))}
    >
      <option value="">{emptyLabel}</option>
      {options.map((o) => (
        <option key={o.id} value={o.id}>
          {labelOf(o)}
        </option>
      ))}
    </Input>
  );
}

ForeignKeySelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.shape({ id: PropTypes.number })]),
  options: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })).isRequired,
  onChange: PropTypes.func.isRequired,
  getLabel: PropTypes.func,
  emptyLabel: PropTypes.string,
};

ForeignKeySelect.defaultProps = { value: null, getLabel: null, emptyLabel: "— none —" };
